import { defineMessages } from '../../i18n/messages';

export const AboutMessages = defineMessages({
    PAGE_TITLE: {
        id: 'about.page_title',
        text: 'About Localingos',
        description: 'Page header on the about page',
    },
    PAGE_SUBTITLE: {
        id: 'about.page_subtitle',
        text: 'Developer-first automated localization, powered by AI.',
        description: 'Subtitle below the page header on the about page',
    },
    WHAT_WE_DO_TITLE: {
        id: 'about.what_we_do_title',
        text: 'What We Do',
        description: 'Section heading for the product overview section',
    },
    WHAT_WE_DO_DESC: {
        id: 'about.what_we_do_desc',
        text: 'Localingos is an automated localization platform built for developers. We use AI to translate your product into 56 locales with zero manual effort. Install our CLI, let agentic AI handle the i18n integration, run <code>localingos sync</code>, and your project is localized.',
        description: 'Body text under the What We Do heading. <code> wraps an inline CLI command',
    },
    WHY_WE_BUILT_THIS_TITLE: {
        id: 'about.why_we_built_this_title',
        text: 'Why We Built This',
        description: 'Section heading for the motivation section',
    },
    WHY_WE_BUILT_THIS_DESC: {
        id: 'about.why_we_built_this_desc',
        text: "Traditional localization is slow, expensive, and painful for developers. Human translation agencies charge $400+/month, take days to deliver, and break your placeholders. We built Localingos to make localization as simple as running a CLI command: fast, accurate, and variable-safe.",
        description: 'Body text under the Why We Built This heading explaining the problem Localingos solves',
    },
    HOW_IT_WORKS_TITLE: {
        id: 'about.how_it_works_title',
        text: 'How It Works',
        description: 'Section heading for the step-by-step workflow section',
    },
    HOW_IT_WORKS_1: {
        id: 'about.how_it_works_1',
        text: 'The CLI detects your tech stack and generates an integration prompt for your AI agent',
        description: 'Step 1 in the How It Works numbered list',
    },
    HOW_IT_WORKS_2: {
        id: 'about.how_it_works_2',
        text: 'Agentic AI (Cursor, Copilot, etc.) handles the entire i18n setup automatically',
        description: 'Step 2 in the How It Works numbered list',
    },
    HOW_IT_WORKS_3: {
        id: 'about.how_it_works_3',
        text: '<code>localingos sync</code> uploads source strings and downloads translations',
        description: 'Step 3 in the How It Works numbered list. <code> wraps an inline CLI command',
    },
    HOW_IT_WORKS_4: {
        id: 'about.how_it_works_4',
        text: 'Only changed content is translated. Diff-based, no wasted quota',
        description: 'Step 4 in the How It Works numbered list',
    },
    HOW_IT_WORKS_5: {
        id: 'about.how_it_works_5',
        text: 'Translations are powered by Amazon Bedrock with variable-safe processing',
        description: 'Step 5 in the How It Works numbered list',
    },
    BUILT_WITH_TITLE: {
        id: 'about.built_with_title',
        text: 'Built With',
        description: 'Section heading for the technology stack list',
    },
    BUILT_WITH_1: {
        id: 'about.built_with_1',
        text: 'Amazon Bedrock for AI-powered translations',
        description: 'List item under the Built With section for the AI translation engine',
    },
    BUILT_WITH_2: {
        id: 'about.built_with_2',
        text: 'AWS infrastructure (DynamoDB, Lambda, SQS, CloudFront)',
        description: 'List item under the Built With section for AWS infrastructure services',
    },
    BUILT_WITH_3: {
        id: 'about.built_with_3',
        text: 'Stripe for subscription billing',
        description: 'List item under the Built With section for the billing provider',
    },
    BUILT_WITH_4: {
        id: 'about.built_with_4',
        text: 'React + Cloudscape for the web dashboard',
        description: 'List item under the Built With section for the frontend framework',
    },
    BREADCRUMB: {
        id: 'about.breadcrumb',
        text: 'About',
        description:
            'Name of this page in the schema.org BreadcrumbList structured data, following the "Home" crumb. Keep it short — it is a navigation trail label, not the page heading.',
    },
});
